import axiosPost from "../axiosPost";

export const migraPasoIns = async (
    { migraPasoCod, migraPasoNombre, gateLugarId, migraTipoDePasoId },
    credentials
) => {
    const body = {
        service: "MigraPasoIns",
        params: {
            merchantId: credentials.merchantId,
            migraPasoCod,
            migraPasoNombre,
            gateLugarId,
            migraTipoDePasoId,
        },
    };

    return await axiosPost(body, credentials);
};
